import { default as _91_46_46_46slug_93COMtpgtIZiMeta } from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/[...slug].vue?macro=true";
import { default as addons6vZSUdIXhqMeta } from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/admin/addons.vue?macro=true";
import { default as migrationUUBUckSDHjMeta } from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/admin/migration.vue?macro=true";
import { default as usersyuIA3IeKSHMeta } from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/admin/users.vue?macro=true";
import { default as workspaces7Hl6MsE8NJMeta } from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/admin/workspaces.vue?macro=true";
import { default as adminLX4UHEXF6cMeta } from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/admin.vue?macro=true";
import { default as ai_45course_45generator3UkhSSTLkUMeta } from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/ai-course-generator.vue?macro=true";
import { default as build2dbY2v96KgMeta } from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/build.vue?macro=true";
import { default as course_45templatesZTl8KvueonMeta } from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/course-templates.vue?macro=true";
import { default as _91id_93k4xGDEDa81Meta } from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/course/[id].vue?macro=true";
import { default as coursesqL2vH0xn9YMeta } from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/dashboard/courses.vue?macro=true";
import { default as dashboard4xel6snhyLMeta } from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/dashboard.vue?macro=true";
import { default as _91token_935F9aDIIUEzMeta } from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/embed/[token].vue?macro=true";
import { default as _91token_931c9MMPyGkoMeta } from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/embed/collection/[token].vue?macro=true";
import { default as _91id_93GOGzkZloKNMeta } from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/folder/[id].vue?macro=true";
import { default as headlessi9HjYEVDvSMeta } from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/headless.vue?macro=true";
import { default as indexRItXTfWQuFMeta } from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/index.vue?macro=true";
import { default as setupG4JUF5wK9gMeta } from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/intercom/setup.vue?macro=true";
import { default as successIcwO2SGPmyMeta } from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/intercom/success.vue?macro=true";
import { default as _91key_93jAlY0OjxRSMeta } from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/invitation/[key].vue?macro=true";
import { default as _91key_93G4P1mbdPRcMeta } from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/learn/[key].vue?macro=true";
import { default as successf0BG7lgos4Meta } from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/payment/success.vue?macro=true";
import { default as pricingwEJTr0Rlq9Meta } from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/pricing.vue?macro=true";
import { default as _91code_93ZzKIkuQiM5Meta } from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/redeem/[code].vue?macro=true";
import { default as redirect5edZKzlhsXMeta } from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/redirect.vue?macro=true";
import { default as _91_46_46_46slug_93yynVNeJPQnMeta } from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/resource/[...slug].vue?macro=true";
import { default as resourcesk5bHqitwRoMeta } from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/resources.vue?macro=true";
import { default as forgot_45passwordbb1sWaIOGpMeta } from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/signin/forgot-password.vue?macro=true";
import { default as indexv51dlxw5n3Meta } from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/signin/index.vue?macro=true";
import { default as readytech5csODSGqlDMeta } from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/signin/readytech.vue?macro=true";
import { default as reset_45password0o11ymq3g0Meta } from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/signin/reset-password.vue?macro=true";
import { default as _91_46_46_46slug_939Vz86p8754Meta } from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/templates/[...slug].vue?macro=true";
import { default as transformmk5KGdqqXnMeta } from "/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/transform.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93COMtpgtIZiMeta || {},
    component: () => import("/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/[...slug].vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: adminLX4UHEXF6cMeta || {},
    component: () => import("/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/admin.vue"),
    children: [
  {
    name: "Addons",
    path: "addons",
    meta: addons6vZSUdIXhqMeta || {},
    component: () => import("/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/admin/addons.vue")
  },
  {
    name: "Migration",
    path: "migration",
    meta: migrationUUBUckSDHjMeta || {},
    component: () => import("/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/admin/migration.vue")
  },
  {
    name: "Users",
    path: "users",
    meta: usersyuIA3IeKSHMeta || {},
    component: () => import("/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/admin/users.vue")
  },
  {
    name: "Workspaces",
    path: "workspaces",
    meta: workspaces7Hl6MsE8NJMeta || {},
    component: () => import("/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/admin/workspaces.vue")
  }
]
  },
  {
    name: "ai-course-generator",
    path: "/ai-course-generator",
    meta: ai_45course_45generator3UkhSSTLkUMeta || {},
    component: () => import("/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/ai-course-generator.vue")
  },
  {
    name: "build",
    path: "/build",
    meta: build2dbY2v96KgMeta || {},
    component: () => import("/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/build.vue")
  },
  {
    name: "course-templates",
    path: "/course-templates",
    meta: course_45templatesZTl8KvueonMeta || {},
    component: () => import("/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/course-templates.vue")
  },
  {
    name: "course-id",
    path: "/course/:id()",
    meta: _91id_93k4xGDEDa81Meta || {},
    component: () => import("/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/course/[id].vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: dashboard4xel6snhyLMeta || {},
    component: () => import("/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/dashboard.vue"),
    children: [
  {
    name: "dashboard-courses",
    path: "courses",
    component: () => import("/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/dashboard/courses.vue")
  }
]
  },
  {
    name: "embed-token",
    path: "/embed/:token()",
    meta: _91token_935F9aDIIUEzMeta || {},
    component: () => import("/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/embed/[token].vue")
  },
  {
    name: "embed-collection-token",
    path: "/embed/collection/:token()",
    meta: _91token_931c9MMPyGkoMeta || {},
    component: () => import("/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/embed/collection/[token].vue")
  },
  {
    name: "folder-id",
    path: "/folder/:id()",
    meta: _91id_93GOGzkZloKNMeta || {},
    component: () => import("/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/folder/[id].vue")
  },
  {
    name: "headless",
    path: "/headless",
    meta: headlessi9HjYEVDvSMeta || {},
    component: () => import("/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/headless.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexRItXTfWQuFMeta || {},
    component: () => import("/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/index.vue")
  },
  {
    name: "intercom-setup",
    path: "/intercom/setup",
    meta: setupG4JUF5wK9gMeta || {},
    component: () => import("/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/intercom/setup.vue")
  },
  {
    name: "intercom-success",
    path: "/intercom/success",
    meta: successIcwO2SGPmyMeta || {},
    component: () => import("/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/intercom/success.vue")
  },
  {
    name: "invitation-key",
    path: "/invitation/:key()",
    meta: _91key_93jAlY0OjxRSMeta || {},
    component: () => import("/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/invitation/[key].vue")
  },
  {
    name: "learn-key",
    path: "/learn/:key()",
    meta: _91key_93G4P1mbdPRcMeta || {},
    component: () => import("/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/learn/[key].vue")
  },
  {
    name: "payment-success",
    path: "/payment/success",
    component: () => import("/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/payment/success.vue")
  },
  {
    name: "pricing",
    path: "/pricing",
    meta: pricingwEJTr0Rlq9Meta || {},
    component: () => import("/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/pricing.vue")
  },
  {
    name: "redeem-code",
    path: "/redeem/:code()",
    component: () => import("/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/redeem/[code].vue")
  },
  {
    name: "redirect",
    path: "/redirect",
    component: () => import("/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/redirect.vue")
  },
  {
    name: "resource-slug",
    path: "/resource/:slug(.*)*",
    meta: _91_46_46_46slug_93yynVNeJPQnMeta || {},
    component: () => import("/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/resource/[...slug].vue")
  },
  {
    name: "resources",
    path: "/resources",
    meta: resourcesk5bHqitwRoMeta || {},
    component: () => import("/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/resources.vue")
  },
  {
    name: "signin-forgot-password",
    path: "/signin/forgot-password",
    component: () => import("/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/signin/forgot-password.vue")
  },
  {
    name: "signin",
    path: "/signin",
    component: () => import("/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/signin/index.vue")
  },
  {
    name: "signin-readytech",
    path: "/signin/readytech",
    component: () => import("/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/signin/readytech.vue")
  },
  {
    name: "signin-reset-password",
    path: "/signin/reset-password",
    component: () => import("/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/signin/reset-password.vue")
  },
  {
    name: "templates-slug",
    path: "/templates/:slug(.*)*",
    meta: _91_46_46_46slug_939Vz86p8754Meta || {},
    component: () => import("/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/templates/[...slug].vue")
  },
  {
    name: "transform",
    path: "/transform",
    meta: transformmk5KGdqqXnMeta || {},
    component: () => import("/home/runner/work/coassemble-author/coassemble-author/frontend/src/views/transform.vue")
  }
]